import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/anim";
import { RGV } from "@/data/content";

export default function ProjectPipeline() {
  return (
    <section id="projects" data-testid="projects-section" className="bg-bg-primary py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="text-brand-teal text-xs font-bold uppercase tracking-[0.25em] mb-4">{RGV.overline}</p>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          {/* Left: name + description */}
          <div className="lg:col-span-7">
            <Reveal>
              <h2 className="font-heading font-extrabold uppercase tracking-tighter text-ink leading-[0.9] text-5xl md:text-7xl lg:text-8xl">
                Rio Grande<br />Valley
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 font-accent italic text-lg md:text-xl text-brand-navy">{RGV.partner}</p>
              <p className="mt-6 max-w-xl text-ink-soft text-base md:text-lg leading-relaxed">{RGV.description}</p>
              <Link
                to={`/news/${RGV.articleSlug}`}
                data-testid="rgv-read-announcement"
                className="mt-8 inline-flex items-center gap-2 text-brand-navy font-semibold hover-underline"
              >
                Read the announcement <ArrowUpRight size={16} />
              </Link>
            </Reveal>
          </div>

          {/* Right: facts */}
          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-px bg-brand-navy/15 border border-brand-navy/15">
              {RGV.facts.map((f, i) => (
                <Reveal key={i} delay={i * 0.08} className="bg-white">
                  <div className="p-7 h-full group hover:bg-brand-navy transition-colors duration-300">
                    <p className="text-ink-soft text-xs uppercase tracking-[0.15em] group-hover:text-white/60 transition-colors">
                      {f.label}
                    </p>
                    <p className="mt-3 font-heading text-2xl md:text-3xl text-brand-navy group-hover:text-brand-teal transition-colors leading-tight">
                      {f.value}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
